exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd]{min-height:calc(100vh - 50px);width:100%;position:relative;overflow:hidden;padding-bottom:100px}.fixed-header+.app-main[data-v-078753dd]{padding-top:50px}.hasTagsView .app-main[data-v-078753dd]{min-height:calc(100vh - 84px);padding-bottom:100px}.hasTagsView .fixed-header+.app-main[data-v-078753dd]{padding-top:84px}.footer[data-v-078753dd]{text-align:center;font-size:12px;position:relative;margin-top:-90px;height:70px;clear:both}\n", ""]);

// exports
